export const sortBoolean = (a: unknown, b: unknown): number =>
  a === b ? 0 : a ? -1 : 1

/**
 * Escapes text for safe interpolation into an HTML string.
 *
 * Only needed where a string is built for `v-html`. Prefer plain `{{ }}` interpolation, which Vue
 * escapes for you -- this exists for the few places that must emit markup, such as joining address
 * lines with `<br>`.
 */
export const escapeHtml = (value: string | null | undefined): string =>
  (value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
